import { create } from "zustand";
import { BrandRFMSetting } from "../models/brandRFMSetting";

interface BrandRFMSettingStore {
  brandRFMSettingId: string | null;
  brandRFMSetting: BrandRFMSetting[];
  setBrandRFMSettingId: (id: string | null) => void;
  setBrandRFMSetting: (brandRFMSetting: BrandRFMSetting[]) => void;
}

export const useBrandRFMSettingStore = create<BrandRFMSettingStore>((set) => ({
  brandRFMSettingId: null,
  brandRFMSetting: [],
  setBrandRFMSettingId: (id) => set({ brandRFMSettingId: id }),
  setBrandRFMSetting: (brandRFMSetting) =>
    set((state) => ({
      brandRFMSetting,
    })),
}));
